import BaseCardBehavior from './BaseCardBehavior';
import { ICardsState } from '../CardReducer';
import CardStateHelper from '../CardStateHelper';
import { isCheatsEnabled } from '../../../Cheats';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { SCORE_VALUE_CARD } from '../../../Constants/Score';
import { CardTask } from '../CardTasks';
import BaseModifierBehavior from '../ModifierBehavior/BaseModifierBehavior';
import { CardStatus } from '../../../Prototype/Level/Card/CardStatus';
import { getCardSuit } from '../../../Utility/CardsHelper';
import { IGameState } from '../../Game/IGameState';

export default class GoldCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState, currentCard: string): boolean {
        const cardState = CardStateHelper.getCardStatus(state, this.cardID);
        if (cardState === CardStatus.IN_PLAY) {
            return (
                super.isPlayable(state, currentCard) &&
                this.isMatch(state, currentCard)
            );
        }
        return super.isPlayable(state, currentCard);
    }

    public isMatch(state: IGameState, cardB: string): boolean {
        // CHEATS
        if (
            window &&
            (window as any).key &&
            (window as any).key.Shift === true &&
            isCheatsEnabled()
        )
            return true;
        //

        const cardAData = state.levelState.cardsState.cards[this.cardID];
        const cardBData = state.levelState.cardsState.cards[cardB];

        // If nothing to match against always match.
        if (!cardBData) {
            return state.levelState.cardsState.inStack.length === 0;
        }

        // If cardB is a joker always match.
        if (cardBData.type === CardType.joker) return true;

        if (
            cardBData.type === CardType.gold &&
            cardAData.type === CardType.gold
        ) {
            if (cardBData.suit === cardAData.suit) {
                return true;
            }
        }
        if (
            cardAData.type === CardType.gold &&
            cardBData.type === CardType.value
        ) {
            if (cardAData.suit === getCardSuit(cardBData.value)) {
                return true;
            }
        }

        return false;
    }

    private modifiersOverriding(state: IGameState): BaseModifierBehavior[] {
        return state.levelState.cardsState.cards[this.cardID].modifiers
            .map(m =>
                CardStateModifierHelper.getModifierBehavior(
                    state,
                    m,
                    this.cardID
                )
            )
            .filter(b => b.overrideCardPlay(state));
    }

    public play(state: IGameState) {
        const cardStatus = CardStateHelper.getCardStatus(state, this.cardID);

        switch (cardStatus) {
            case CardStatus.IN_PLAY:
                const modBehaviors = this.modifiersOverriding(state);

                // Modifiers can override the default 'play' method.
                if (modBehaviors.length > 0) {
                    // Modifiers are played instead.
                    for (let i = 0, n = modBehaviors.length; i < n; i++) {
                        state = CardStateModifierHelper.playModifier(
                            state,
                            modBehaviors[i].modifier,
                            modBehaviors[i].cardID
                        );
                    }
                } else {
                    state = CardStateHelper.clearUndoHistory(state);
                    state = CardStateHelper.increaseStreak(
                        state,
                        SCORE_VALUE_CARD
                    );
                    const cardScore = state.levelState.cardsState.streakScore;
                    state = CardStateHelper.addTurnScore(state, cardScore);
                    state = CardStateModifierHelper.updateModifiers(
                        state,
                        this.cardID
                    );
                    state = CardStateHelper.setCardFolded(state, this.cardID);
                    state = CardStateHelper.setStateTaskData(state, {
                        task: CardTask.MATCH,
                        cards: [this.cardID],
                        cardScore: cardScore,
                    });
                    state = CardStateHelper.updateCards(state);
                    state = CardStateModifierHelper.onCardPlayed(
                        state,
                        this.cardID
                    );
                    state = CardStateHelper.checkStreakBonus(state);

                    break;
                }

            case CardStatus.IN_STACK:
            case CardStatus.FOLDED:
            case CardStatus.DISCARDED:
            case CardStatus.UNKNOWN:
        }

        return state;
    }
}
